import CustomerSetup from './CustomerSetup';
export default CustomerSetup;
